<template>
  <div class="sc-message self-auto">
    <div class="sc-message--content received carousel">
      <!---->
      <div class="sc-message--carousel-container sc-message-bubble received">
        <div class="sc-message--carousel">
          <div class="sc-message--carousel-card">
            <div class="sc-message--carousel-card-detail">
              <img src="https://amio-assets.s3.eu-central-1.amazonaws.com/watch_1.jpg">
              <p class="sc-message--carousel-card-title">
                Chronograph Watch
              </p>
              <p class="sc-message--carousel-card-content">
                A timeless piece for any occasion.
                Price: 5,990 CZK
              </p>
            </div>
            <div class="sc-message--carousel-card-buttons">
              <!---->
              <a
                class="button"
                :style="styles"
              >
                <span class="button-text">
                  Buy now
                </span>
              </a>
              <!---->
            </div>
          </div>
          <div class="sc-message--carousel-card">
            <div class="sc-message--carousel-card-detail">
              <img src="https://amio-assets.s3.eu-central-1.amazonaws.com/watch_2.jpg">
              <p class="sc-message--carousel-card-title">
                Gold-Tone Timepiece
              </p>
              <p class="sc-message--carousel-card-content">
                A potential heirloom.
                Price: 12,800 CZK
              </p>
            </div>
            <div class="sc-message--carousel-card-buttons">
              <!---->
              <a
                class="button"
                :style="styles"
              >
                <span class="button-text">
                  Buy now
                </span>
              </a>
              <!---->
            </div>
          </div>
        </div>
        <!---->
        <div class="sc-message--carousel-arrow-container arrow-right">
          <button class="sc-message--carousel-arrow">
            <arrowRightIcon />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import arrowRightIcon from '@/assets/images/icons/chat-widget/arrowRightIcon.vue'

export default {
  name: 'ChatPreviewCarousel',

  components: {
    arrowRightIcon
  },

  props: {
    themeConfig: {
      type: Object,
      required: true
    }
  },

  computed: {
    styles() {
      return {
        '--button-text': this.themeConfig.sentMessage.carouselButton.text,
        '--button-text-hover': this.themeConfig.sentMessage.carouselButton.textHover,
        '--button-bg-hover': this.themeConfig.sentMessage.carouselButton.bgHover
      }
    }
  }
}
</script>
